const ingredientsInitial = [
    {
        id: 'tomato-sauce',
        name: 'Tomato sauce',
        items: [
            {
                name: 'Garlic',
                preparation: 'crushed',
                number: '1',
                unit: 'head'
            },
            {
                name: 'Red onion',
                preparation: 'chopped',
                number: '1',
                unit: 'large'
            },
            {
                name: 'Olive oil',
                number: '0.25',
                unit: 'cup',
                numberMetric: '85',
                unitMetric: 'g'
            },
            {
                name: 'Anchovies (oil packed)',
                number: '3',
                note: 'optional'
            },
            {
                name: 'Red pepper flakes',
                number: '0.5',
                unit: 'tsp'
            },
            {
                name: 'Tomato paste',
                number: '1',
                unit: 'Tbsp'
            },
            {
                name: 'White wine',
                number: '0.25',
                unit: 'cup',
                numberMetric: '59',
                unitMetric: 'g'
            },
            {
                name: 'Whole peeled tomatoes',
                number: '2',
                unit: '28oz cans',
                numberMetric: '2',
                unitMetric: '794g cans'
            },
            {
                name: 'Fresh basil',
                preparation: 'chopped',
                number: '0.25',
                unit: 'cup',
                numberMetric: '20',
                unitMetric: 'g'
            },
            {
                name: 'Dried oregano',
                number: '0.5',
                unit: 'tsp'
            },
            {
                name: 'Salt (kosher)'
            }
        ],
        note: 'Making the sauce from scratch is optional. Instead you can buy your favorite tomato sauce and use that.'
    },
    {
        id: 'eggplant-parmesan',
        name: 'Eggplant parmesan',
        items: [
            {
                name: 'Italian Eggplants',
                preparation: 'peeled & sliced',
                number: '4',
                unit: 'medium'
            },
            {
                name: 'Panko breadcrumbs',
                number: '3',
                unit: 'cups',
                numberMetric: '300',
                unitMetric: 'g'
            },
            {
                name: 'Dried oregano',
                number: '1.5',
                unit: 'tsp'
            },
            {
                name: 'Black pepper (ground)',
                number: '1',
                unit: 'tsp'
            },
            {
                name: 'Parmesan',
                preparation: 'grated',
                number: '1.5',
                unit: 'cups',
                numberMetric: '180',
                unitMetric: 'g'
            },
            {
                name: 'Flour',
                number: '1.5',
                unit: 'cups',
                numberMetric: '187',
                unitMetric: 'g'
            },
            {
                name: 'Eggs',
                number: '5',
                unit: 'large'
            },
            {
                name: 'Olive oil',
                number: '1.3',
                unit: 'cups',
                numberMetric: '442',
                unitMetric: 'g'
            },
            {
                name: 'Fresh basil',
                preparation: 'chopped',
                number: '0.25',
                unit: 'cup',
                numberMetric: '20',
                unitMetric: 'g',
                note: 'Keep some extra leaves for garnish'
            },
            {
                name: 'Fresh parsely',
                preparation: 'chopped',
                number: '0.25',
                unit: 'cup',
                numberMetric: '20',
                unitMetric: 'g'
            },
            {
                name: 'Low-moisture Mozzarella',
                preparation: 'grated',
                number: '1.3',
                unit: 'cups',
                numberMetric: '270',
                unitMetric: 'g'
            },
            {
                name: 'Tomato sauce',
                number: '32',
                unit: 'oz',
                numberMetric: '910',
                unitMetric: 'g',
                note: 'Marinara will work well, but can be whatever you like',
                filterId: 'tomato-sauce'
            },
            {
                name: 'Fresh mozzarella',
                number: '8',
                unit: 'oz',
                numberMetric: '270',
                unitMetric: 'g'
            },
        ]
    }
]

export const ingredients = ingredientsInitial.map((ingredient) => ({
    ...ingredient,
    items: ingredient.items.map((item) => ({
        ...item,
        checked: false,
    })),
}));